/**
 * Clean a report cell before it is handed to the CSV/Excel writers.
 * Double quotes and embedded line breaks are the characters that break the
 * downstream Excel imports, so they are removed/flattened here.
 */
export const sanitizeCsvValue = (
  value: string | number | boolean
): string | number | boolean => {
  if (typeof value !== 'string') {
    return value;
  }

  return value
    .replace(/["]/g, '')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
};
